import { navigate, graphql, useStaticQuery } from "gatsby"
import React, { useState, useEffect } from "react"

export const Context = React.createContext({})

const query = graphql`
  query {
    allStrapiArea {
      nodes {
        id
        area_bg
        area_en
        post_code
        coefficient
        pop
        district {
          name
        }
      }
    }
  }
`

const buildStambolovoRanking = (initiativeNodes, areas) =>
  areas
    .filter(area => area.district?.name === "stambolovo")
    .sort((a, b) => a.area_bg.localeCompare(b.area_bg))
    .map(area => ({
      key: area.area_en,
      label: `${Number(area.post_code) !== 6300 ? "с." : "гр."} ${area.area_bg}`,
      initiatives: initiativeNodes
        .filter(el => el.attributes?.area_en === area.area_en)
        .map(el => ({
          id: el.id,
          heading:
            el.attributes?.haeding?.data?.haeding ?? el.attributes?.haeding ?? "",
          votes: Number(el.attributes?.votes) || 0,
        }))
        .sort((a, b) => b.votes - a.votes),
    }))

const SiteProvider = props => {
  const areaData = useStaticQuery(query)
  const areas = areaData.allStrapiArea.nodes
  const rankingAreas = areas.filter(area => area.district?.name === "haskovo")

  const [findPost, setFindpost] = useState(null)
  const [formIdeaGallery, setFromIdeaGallery] = useState(false)
  const [commingSoon, setCommingSoon] = useState(false)
  const [currentFilter, setCurrentFilter] = useState("all")
  const [inititativeData, setInititativeData] = useState(null)
  const [inititativeDataRaw, setInititativeDataRaw] = useState(null)
  const [stambolovoRanking, setStambolovoRanking] = useState([])
  const [loading, setLoading] = useState(false)

  const findPostHandler = id => {
    setFindpost(id)
    navigate("/useful")
  }

  function sortByVotes(a, b) {
    return Number(a.votes) - Number(b.votes)
  }

  const getInitiatives = async () => {
    setLoading(true)
    const instance = process.env.GATSBY_INSTANCE || "main"
    const requestOptions = {
      method: "GET",
      redirect: "follow",
    }

    try {
      const baseUrl = `https://halobg.herokuapp.com/api/initiatives?instance=${instance}&pagination[pageSize]=100`

      const firstPage = await fetch(`${baseUrl}&pagination[page]=1`, requestOptions).then(r => r.json())
      const pageCount = firstPage?.meta?.pagination?.pageCount ?? 1
      const initiativeNodes = firstPage?.data || []

      for (let page = 2; page <= pageCount; page++) {
        const nextPage = await fetch(`${baseUrl}&pagination[page]=${page}`, requestOptions).then(r => r.json())
        initiativeNodes.push(...(nextPage?.data || []))
      }

      // console.log("API area_en values:", initiativeNodes.map(el => ({ id: el.id, area_en: el.attributes?.area_en, votes: el.attributes?.votes })))
      // console.log("Gatsby area_en values:", rankingAreas.map(a => a.area_en))

      setInititativeDataRaw(initiativeNodes)
      setStambolovoRanking(buildStambolovoRanking(initiativeNodes, areas))

      const areasInfo = rankingAreas
        .map(area => {
          const info = {
            area_bg: area.area_bg,
            area_en: area.area_en,
            population: area.pop,
            coefficient: area.coefficient,
            post_code: area.post_code,
            votes: 0,
          }
          initiativeNodes.forEach(el => {
            const initiativeArea = el.attributes.area_en

            if (initiativeArea === area.area_en) {
              info.votes = info.votes + Number(el.attributes.votes)
            }
          })

          return info
        })
        .map(area => {
          return {
            ...area,
            votes: Number(
              (
                ((area.votes * Number(area.coefficient)) /
                  Number(area.population)) *
                100
              ).toFixed(3)
            ),
          }
        })

      // const sortedItems = areasInfo.sort(sortByVotes).slice(-5).reverse()
      const sortedItems = areasInfo.sort(sortByVotes).reverse()

      setInititativeData(sortedItems)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (!inititativeData) {
      getInitiatives()
    }
  }, [])

  return (
    <Context.Provider
      value={{
        findPostHandler,
        setFindpost,
        findPost: findPost,
        setFromIdeaGallery,
        formIdeaGallery,
        setCommingSoon,
        commingSoon,
        setCurrentFilter,
        currentFilter,
        loading,
        inititativeData,
        stambolovoRanking,
        areas,
        getInitiatives,
        inititativeDataRaw,
      }}
    >
      {props.children}
    </Context.Provider>
  )
}

export default SiteProvider
